/* eslint-disable max-classes-per-file */
import { Expose } from 'class-transformer'

class UserType {
  @Expose() id: number

  @Expose() profilePageSlug: string
}

export class BookmarkPenNameType {
  @Expose() user: UserType

  @Expose() firstPenName: string
}
